<template>
  <Card
    class="text-center flex flex-col gap-4"
    v-if="!titles || titles?.length"
  >
    <h1 class="text-lg font-bold tracking-wide">Access Locked Chapters</h1>
    <slot name="description" v-if="description || $slots.description">
      <p class="text-sm sm:text-base">{{ description }}</p>
    </slot>

    <div
      v-if="titles"
      class="mt-auto group overflow-hidden rounded-lg aspect-video select-none flex items-center justify-center gap-4"
      :class="{
        subscribe: subscribeLink,
        'stage-gradient-nami': !subscribeLink,
        'stage-gradient-yellow': subscribeLink,
      }"
      @click="showAll = true"
    >
      <TitleDisplayCoverTitle
        v-for="title in titles.slice(0, 3)"
        class="w-[25%] drama-3"
        :class="{
          'drama-yellow-400': subscribeLink,
          'drama-nami-nami-blue': !subscribeLink,
        }"
        :title="title"
        hide-title
      />
    </div>
  </Card>
</template>

<script setup lang="ts">
import type { TitleEntity } from "~/src/api";

defineProps<{
  titles?: TitleEntity[] | false | null;
  subscribeLink?: string;
  description?: string;
}>();

const showAll = ref(false);
</script>
